export default {
  // 获取公众号签名
  'wechat.signature': {
    uri: 'wechat/jsapi-signature',
    auth: false
  },
  // 反馈详情
  'advice': {
    uri: 'advices/:id',
    auth: 'required'
  },
  // 纠错详情
  'corrections': {
    uri: 'corrections/:id',
    auth: 'required'
  },
  // 图片
  'file.view': {
    uri: 'files/:id',
    auth: false
  },
  'video.view': {
    uri: 'videos/:id',
    auth: false
  },
  // 文章
  'article.view': {
    uri: 'articles/:id',
    auth: false
  },
  'article-category': {
    uri: 'article-categories',
    auth: false
  },
  'article': {
    uri: 'articles',
    auth: false
  },
    // 课程列表
  'courses': {
    uri: 'courses',
    auth: false
  },
  'course.view': {
    uri: 'courses/:id',
    auth: 'optional'
  },
  'course.chapters': {
    uri: 'courses/:id/chapters',
    auth: 'optional'
  },

  // 分类
  'category.index': {
    uri: 'categories',
    auth: false
  },
  'category.view': {
    uri: 'categories/:id',
    auth: false
  },
  'major-subject.index': {
    uri:'major-subjects',
    auth: false
  },
  'user.enrollment': {
    uri: 'users/:id/enrollment',
    auth: 'required'
  },
  // 文档
  'document.index': {
    uri: 'documents',
    auth: false
  },
  'document.view': {
    uri: 'documents/:id',
    auth: 'optional'
  },
  'document.update': {
    uri: 'documents/:id',
    auth: false
  },

  // 优惠券详情
  'coupon-stock.view': {
    uri: 'coupon-stocks/:id',
    auth: false
  },

  // 领取优惠券
  'coupon.create': {
    uri: 'coupon-stocks/:id/coupons',
    auth: 'required'
  },

  // 账号绑定(绑定openid)
  'create-auth': {
    uri: 'users/:id/create-auth',
    auth: 'required'
  },

  // 用户
  // 可查询用户信息&&更新用户信息
  'user.view': {
    uri: 'users/:id',
    auth: 'required'
  },
  'check': {
    uri: 'check',
    auth: false
  },
  'check-block': {
    uri: 'check-block',
    auth: false
  },
  'reg': {
    uri: 'reg',
    auth: false
  },
  'auth': {
    uri: 'auth',
    auth: false
  },
  'wxreg': {
    uri: 'wxreg',
    auth: false
  },
  // 更新用户
  'user.index': {
    uri: 'users/:id',
    auth: 'required'
  },

  //协议
  'user-contract': {
    uri:'user-contracts/:number',
    auth: false
  },
  'user-contract.signment': {
    uri: 'user-contracts/:id/signment',
    auth: 'required'
  },

  // 微信
  'wechat.oauth2': {
    uri: 'wechat/oauth2',
    auth: false
  },

  // 工具
  'tool.sms-sender': {
    uri: 'tool/sms-sender',
    auth: false
  },
  'tool.tts-sender': {
    uri: 'tool/tts-sender',
    auth: false
  },
  'captcha-generator': {
    uri: 'captcha/generator',
    auth: false
  },
  // 规则
  'rules': {
    uri: 'categories/:id/rules',
    auth: false
  },
  // 接待微信
  'weixins.service': {
    uri: 'weixins/service',
    auth: false
  },
  // 弹框微信加好友
  'weixins.index': {
    uri: 'weixins/:id',
    auth: false
  },
  // 题库
  'exam.paper-categories': {
    uri: 'exams/:id/paper-categories',
    auth: false,
  },
  'exam.index': {
    uri: 'exams',
    auth: false,
  },
  'course.index': {
    uri: 'courses',
    auth: false
  },
  // 协议
  'user.ongoing-contract': {
    uri: 'users/:id/ongoing-contract',
    auth: 'required'
  },
  'copie.view': {
    uri: 'copies/:id',
    auth: false
  },
  'coupons.view': {
    uri: 'coupons/:id',
    auth: false
  },
  'weixins.view': {
    uri: 'weixins/:id',
    auth: false
  },
  // 获取视频播放信息
  'videos.view': {
    uri: 'videos/:id',
    auth: 'optional'
  },
  // 更新历史观看记录
  'course-section.watch': {
    uri: 'course-sections/:id/watch',
    auth: 'required'
  },
  // 政策条款
  'policies': {
    uri: 'policies',
    auth: false
  },
  'activities': {
    uri: '/activities/:name',
    auth: false,
  },
  'files': {
    uri: 'files',
    auth: 'required'
  },
  'user-contract.view': {
    uri: 'user-contracts/:id',
    auth: 'required'
  },
  'company.view': {
    uri: 'companies/:id',
    auth: 'required'
  },
  'user-contract.handsign': {
    uri: 'user-contracts/:id/hand-sign',
    auth: 'required'
  },
  'user-contract.payment': {
    uri: 'user-contracts/:id/payment',
    auth: 'required'
  },
  // 分校
  'online-account.appid': {
    uri: 'online-accounts/appid',
    auth: 'required'
  },
  'user-order.view': {
    uri: 'user-orders/:id',
    auth: 'required'
  },
  'user.coupons': {
    uri: 'users/:id/coupons',
    auth: 'required',
  },
  'coupons': {
    uri: 'coupons',
    auth: 'required',
  }
};
